export default class sidebarLanguages {
    constructor() {
        return {
            template: require('../../../../views/maileditor/sidebar-languages.html'),
            replace: true,
            restrict: 'E',
            controller: EmailLanguageCtrl,
            controllerAs: 'lang'
        }       
    }
}

class EmailLanguageCtrl {
    constructor($scope) {
        this._scope = $scope;

        this.currentLanguage = null;

        this._scope.$on('mailEditor:template:parseTemplate', (event, templateHtml) => {
            this.setAvailableLanguages(templateHtml);
        });

        this._scope.$on('mailEditor:state:init', (event, data) => {
            if (data.dispatcher.email.language != null) {
                this.currentLanguage = data.dispatcher.email.language.data.code;
            }
        });
        
        this._scope.$on('mailEditor:language:get', (event, callback) => {
            return callback(this.currentLanguage);
        });

        this._scope.$on('mailEditor:element:handleAdded', () => {
            if (this.currentLanguage) {
                this._scope.$emit('mailEditor:language:initBlocks', this.currentLanguage);
            }
        });
        $scope.$on('rmLanguages:availableLanguages', (event, data) => {
            this.availableLanguages = data.languages;
            this.currentLanguage = data.currentLang;
        })
    }
    
    toggleLanguage() {
        this._scope.$emit('mailEditor:setLanguage', this.currentLanguage);
        this._scope.$emit('smsEditor:language:toggle', this.currentLanguage);
    }

    setAvailableLanguages(source) {
        let parsedLanguages = source.match(/data-available-languages="([\w|]+)"/);

        if (parsedLanguages) {
            this.availableLanguages = parsedLanguages[1].split('|');

            this.setLanguageIfItDoesNotExist(this.availableLanguages[0]);
        } else {
            this.availableLanguages = [];
        }
    };

    setLanguageIfItDoesNotExist(lang) {
        if (! this.currentLanguage) {
            this.currentLanguage = lang;
        }
    };
}